export default "__VITE_ASSET__ddipw$Xp__"